import { ReactNode } from 'react';

import { Box, Stack, Typography } from '@mui/material';

interface TimelineContextProps {
  title: string;
  detail?: ReactNode;
}

export default function TimelineContext({
  title,
  detail,
}: TimelineContextProps) {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={{ xs: 0.5, sm: 2 }}
      justifyContent="space-between"
      alignItems={{ xs: 'stretch', sm: 'center' }}>
      <Typography
        component="h2"
        variant="h6"
        sx={{
          color: 'text.primary',
          fontSize: '18px',
          fontWeight: 800,
          lineHeight: '22.5px',
        }}>
        {title}
      </Typography>
      {detail != null && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'flex-end', sm: 'flex-start' },
          }}>
          {typeof detail === 'string' ? (
            <Typography
              variant="body2"
              sx={{
                color: 'text.secondary',
                fontSize: '12px',
                fontWeight: 700,
                lineHeight: 'normal',
                textAlign: { xs: 'right', sm: 'left' },
              }}>
              {detail}
            </Typography>
          ) : (
            detail
          )}
        </Box>
      )}
    </Stack>
  );
}
